import Vue from 'vue';
import axios from 'axios';
import qs from 'qs'
axios.defaults.headers.common['X-Requested-By'] = 'eshipping';


const apiUrl = '/api/harbour-server/';

const get = (url, data) => {
    return axios.get(apiUrl + url, {
        params: data
    });
};

const post = (url, data,type) => {
    if(type == 2){
        return axios.post(apiUrl + url, data);
    }else{
        return axios.post(apiUrl + url, qs.stringify(data));
    }
};

let user = (data) => {
    return get('user/current', data);
};
let login = (data) => {
    return post('user/login', data);
};
let logout = (data) => {
    return get('user/logout', data);
};
let statistics = (data) => {
    return get('duckBill/orderWorkBenchMobile/statistics', data);
};
let list = (data) =>{
    return get('duckBill/orderTrackInfoMobile/list',data);
};
let detial = (data) =>{
    return get('duckBill/containerInfomobile/detial',data);
};
let buyer = (data) =>{
    return post('app/clp/image',data,2);
};
let active = (data) =>{
    return get('/midAutumn/userInfo',data);
};
let urgeDoorArrived = (data) => {
    return post('duckBill/urgeDoorArrived',data, 2)
}


export default {
  user: user,
  login: login,
  logout: logout,
  statistics: statistics,
  list: list,
  detial,
  active,
  buyer,
  urgeDoorArrived,
}



// WEBPACK FOOTER //
// ./src/h5Api/defaultApi.js